import { BifrostBackendApi } from "../gateways/BifrostBackendApi.js";
import { store } from "../store";
import appConfig from "../appconfig";

// const mockData = {
// 	"1303": {
// 		"shopName": "føtex Brønderslev",
// 		"00000000-0000-0000-0000-000000000202": [
// 			{
// 				"totalQuantity": 11,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"8f824498-4a13-4977-9109-05b2ec2ec03d": [
// 			{
// 				"totalQuantity": 33,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"70259def-0a0b-411a-b1ae-bab58292247d": [
// 			{
// 				"totalQuantity": 55,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000201": [
// 			{
// 				"totalQuantity": 33,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000203": [
// 			{
// 				"totalQuantity": 55,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"6f0a6b42-764d-4fd5-9ea6-eef14e02d58e": [
// 			{
// 				"totalQuantity": 11,
// 				"intervalIndex": 0
// 			}
// 		]
// 	},
// 	"1308": {
// 		"shopName": "føtex Silkeborg, Torvet",
// 		"8f824498-4a13-4977-9109-05b2ec2ec03d": [
// 			{
// 				"totalQuantity": 4,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"6f0a6b42-764d-4fd5-9ea6-eef14e02d58e": [
// 			{
// 				"totalQuantity": 4,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"70259def-0a0b-411a-b1ae-bab58292247d": [
// 			{
// 				"totalQuantity": 4,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000201": [
// 			{
// 				"totalQuantity": 14,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000202": [
// 			{
// 				"totalQuantity": 14,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000203": [
// 			{
// 				"totalQuantity": 1,
// 				"intervalIndex": 0
// 			}
// 		]
// 	}
// };
	
const ProductOrderCountProvider = {
	async findProductOrderCount(shopId = "") {
		const queryData = {};
		if (shopId) {
			queryData.shopId = shopId;
		}
		const result = await BifrostBackendApi.get("/product-order-count", {
			headers: { Authorization: store.getters.jwtToken },
			params: queryData
		});

		return result.data;
	},
	// async findProductIntervalCount() {
	// 	return mockData;
	// }
	async findProductIntervalCount({ productIds, intervals }) {
		const queryData = {
			productIds,
			intervals,
			tenantId: appConfig.tenantId
		};
		const result = await BifrostBackendApi.get("/product-monitoring", {
			headers: { Authorization: store.getters.jwtToken },
			params: queryData
		});

		return result.data;
	}
};

export default Object.freeze(ProductOrderCountProvider);
